import { boolean } from 'yup';
import { useCreditCardSchema } from '../../../../../payment/ui/credit-card/form/helpers/useCreditCardSchema';

export function useNewCardSchema() {
	const creditCardSchema = useCreditCardSchema();

	return creditCardSchema
		.shape({
			saveCreditCard: boolean(),
		})
		.required();
}
